"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectConfigurationMode = exports.actionTypes = exports.SELECT_CONFIGURATION_MODE = void 0;
var SELECT_CONFIGURATION_MODE = exports.SELECT_CONFIGURATION_MODE = 'SELECT_CONFIGURATION_MODE';
var actionTypes = exports.actionTypes = {
  SELECT_CONFIGURATION_MODE: SELECT_CONFIGURATION_MODE
};
var selectConfigurationMode = exports.selectConfigurationMode = function selectConfigurationMode(mode) {
  return {
    type: actionTypes.SELECT_CONFIGURATION_MODE,
    mode: mode
  };
};